import {Vue} from 'vue-property-decorator';
import VueMask from 'v-mask';


Vue.use(VueMask, {
	placeholders: {
		'#': null, // passing `null` removes default placeholder, so `#` is treated as character
		D: /\d/, // define new placeholder
	}
});
